import { render, staticRenderFns } from "./priceRequest.vue?vue&type=template&id=e24d66a6&"
import script from "./priceRequest.vue?vue&type=script&lang=js&"
export * from "./priceRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports